var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaylist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.6 14.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f0f7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HitDiscovery"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,3.78a.68.68,0,0,1,.72-.44H7.19a.57.57,0,0,1,.59.41.56.56,0,0,1-.43.69l-.24,0H.74A.7.7,0,0,1,0,4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,.42A.7.7,0,0,1,.74,0H7.15a.6.6,0,0,1,.62.38.56.56,0,0,1-.49.74H.72A.67.67,0,0,1,0,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10.45A.69.69,0,0,1,.74,10H3.83a.56.56,0,0,1,.62.55.54.54,0,0,1-.53.57H.54A.58.58,0,0,1,0,10.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,7.13a.64.64,0,0,1,.7-.44H3.88a.55.55,0,0,1,.54.75.51.51,0,0,1-.49.35H.53A.57.57,0,0,1,0,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,10.49V.64A.57.57,0,0,1,10.52,0a.55.55,0,0,1,.59.38,3.25,3.25,0,0,0,1.13,1.66c.45.38,1,.7,1.44,1A4.61,4.61,0,0,1,15,4.44a3.88,3.88,0,0,1,.46,2.88,5.63,5.63,0,0,1-1,2.34l-.18.22a.56.56,0,0,1-.74,0,.55.55,0,0,1-.1-.74h0a.67.67,0,0,0,.13-.81,4,4,0,0,0-2.35-2.52.83.83,0,0,0-.12,0V6c0,2,0,4,0,6A2.19,2.19,0,0,1,9.7,14.2a3.12,3.12,0,0,1-3.38-.43,1.89,1.89,0,0,1,0-3,3.28,3.28,0,0,1,3.56-.35Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylist);
export default __webpack_public_path__ + "static/media/playlist.03a448da1a3a0fdddb3ea25ea1fa1dcf.svg";
export { ForwardRef as ReactComponent };